class KlaviyoLeadsSeeker extends HTMLElement {
  connectedCallback() {
    const idsString = this.dataset.klaviyoLeadsIds;
    if (!idsString) return;
    const idsStringArray = idsString.split(',').map(id => id.trim());

    window.addEventListener("klaviyoForms", (e) => {
      if (e.detail.type === "submit" && idsStringArray.includes(e.detail.formId) && typeof window.fbq === "function") {
        window.fbq('track', 'Lead', {
          formId: e.detail.formId,
          email: e.detail.metaData.$email || '',
          source: e.detail.metaData.$source || '',
        });
      }
    });
  }
}

if (!customElements.get('klaviyo-leads-seeker')) {
  customElements.define('klaviyo-leads-seeker', KlaviyoLeadsSeeker);
}